import React, { useState, useEffect } from 'react'
import { Spinner } from '../common/atoms';
import { companyMailerApi } from '../../services';
import { successOrFailureToaster } from '../common/atoms/messages';
import {changeTheme, exit_icon, revert} from '../../assets/images'
import TestMailModal from '../modals/TestMailModal';
import { useHistory, useLocation } from 'react-router-dom';
import { handleAppError } from '../handlers';
import { EMAIL_REGEX } from '../../constants/companyMailer';
import PopUpModals from '../modals/PopUpModals';
import UnlayerEmailEditor from './UnlayerEmailEditor';
import { Tooltip } from 'antd';

const MailConfig = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [test, setTest] = useState({mail: '', testMail: false, data: {}});
    const [exitModal, setExitModal] = useState(false);
    const [revertModal, setRevertModal] = useState(false);
    const [data, setData] = useState({
        id: '',
        sender: '',
        subject: '',
        preview: '',
        content: '',
        template_data: '',
        edit: false,
        pageloading: true,
        backPath: ''
    })

    useEffect(() => {
        setData((prev) => 
            {return {...prev,
            ...{id: location.state.id, 
                backPath: location.state.backPath,
            edit: location.state.show}}})
        getMailerContent(location.state.id)
    },[])

    const getMailerContent = (id) => {
        const options = { id: id}
        companyMailerApi.show_mailer(
          options,
          (res) => {
            let data = res.data.mailer;
            let subState = {
                pageloading: false,
                subject: data.subject,
                content: data.content,
                preview: data.preview,
                sender: data.sender,
                template_data: data.template_data
            };
            setData((prev) => {
              return{...prev,...subState}
              })
          },
          (err) => handleAppError(err)
        )
      }

      const updateMailer = (subData, check = null) => { 
        const options = { id: data.id , data: subData}
        companyMailerApi.update_mailer(
          options,
          (res) => {
              if(res.data.msg === 'successfully saved' && check === 'save' ){
                let message = 'Your theme has been saved sucessfully'
                successOrFailureToaster({ message, type: 'success'})
                history.goBack()
              }else if(check === 'preview'){
                history.goBack()
              }
              else{
                successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
              }
            },
          (err) => { 
            handleAppError(err)
          }
        )
      }

      const sendTest = () => {
        if(handleValidation(test.mail)){
          test.mail.split(',').map((mail) => {
            const options = { id: test.data.id, data: {...test.data, email: mail.trim()} }
  
            companyMailerApi.test_mail(
              options,
              (res) => {
                if(res.data.message === "success"){
                  let message = `Test email sent successfully to: ${test.mail.replace(',',', ')}`
                  successOrFailureToaster({ message, type: 'success'})
                  setTest((prev) => { return {...prev,...{testMail: false}}})
                  history.push(data.backPath)
                }else{
                  successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
                }
              },
              (err) => handleAppError(err)
            )
          })
          }else{
            alert('Not a valid email address.')
          }
      }
  
      const handleValidation = (email) => {
        let formIsValid = true
        email.split(',').map((mail) => {
        if (!mail.trim().match(EMAIL_REGEX)){
          formIsValid = false
        }
        })
        return formIsValid
      }

      const undoContent = () => {
        const options = { id: location.state.id}
        companyMailerApi.revert_to_original(
          options,
          (res) => {
            if(res.data.message === 'success'){
              let message = 'Your theme successfully reverted to original'
              successOrFailureToaster({ message, type: 'success'})
              setRevertModal(!revertModal)
              window.location.reload()
            }else{
              successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
            }
          },
          (err) => handleAppError(err)
        )
      }

      const testMailFunc = (e) => {
        let data = test.testMail;
        let subState = {testMail: !data}
        setTest((prevValues) => {
          return{...prevValues,...subState}
        });
      }

      const sentTestMail = (e) => {
        let subState = {testMail: true, data: data}
        setTest((prev) => {
          return{...prev,...subState}
        })
        
      }

      const sanitize = (html) => {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        return doc.innerHTML;
      }

      const updateValue = (data) => {
        let subState = {...data, edit: true, pageloading: false};
        setData((prev) => {
            return{...prev,...subState}
        })
      }

      const prevPage = () => {
        updateMailer({content: data.content, template_data: data.template_data}, 'preview')
      }

      const saveToDraft = (data) => {
        let subState = {content: data, pageloading: false};
        setData((prev) => {
            return{...prev,...subState}
        })
        updateMailer(data, 'save');
      }

      const exitEditor = () => {
        setExitModal(!exitModal);
      }

      const revertToOriginal = () => {
        setRevertModal(!revertModal)
      }

      const html_render = (height) => {
        return(
              <div className='mt-4'>
                <div style={{background: '#F5F7F9'}}>
                  <div className='font-semibold text-base mx-5'><strong className='font-semibold'>From:    </strong>{data.sender}</div>
                  <div className='font-semibold text-base mx-5'><strong className='font-semibold'>Subject:    </strong>{data.subject}</div>
                  <p className='font-normal text-sm mx-4 pl-16'>
                    {(data?.preview).length < 86 ? `${data?.preview}` : `${data?.preview.substring(0,86)}...` }
                  </p>
                </div> 
                <hr/>
                <div class="container">
                  <iframe srcdoc={sanitize(data.content)} width='100%' height={height} sandbox loading></iframe>
                </div>
              </div>
        )
      }

      return(
        <Spinner visible={data.pageloading}>
             { test.testMail && 
            <TestMailModal 
              title='Send a Test Email' 
              description='Send a test to' 
              onClose={testMailFunc} 
              onSave={sendTest} 
              inputVal={(val) => {setTest((prev) => {return{...prev,...{mail: val}}})}} 
            />
          }
              {data.edit ?
              <div>
              <div className='absolute right-0 w-full'>
                <div class='bg-white py-4 px-7 float-left flex flex-row'>
                  <img src={changeTheme} className='mx-2'/>
                  <p className='font-semibold text-xl my-2' style={{color: '#324467'}}>Preview & test</p>
                </div>
                <div className='bg-white py-4 px-7 float-right'>
                  <Tooltip
                      placement='bottomLeft'
                      overlayStyle={{maxWidth: '235px'}}
                      color={'#0D1A35'}
                      key='pink'
                      title={`${!data?.content ? 'Ensure the email content is saved before initiating the teaser 1.' : ''}`}
                      align
                    >
                      <button disabled={!data.content} onClick={sentTestMail} className={`${data?.content ? 'cursor-pointer hover:bg-blue-50 text-blue-600' : 'cursor-not-allowed hover:bg-gray-100'} transition text-base font-semibold border-2 mx-4 rounded-md px-6 py-3`}>Send test mail</button>
                    </Tooltip>
                  <button onClick ={prevPage} className='text-white text-base bg-blue-600 hover:bg-blue-500 transition font-semibold rounded-md px-6 py-3'>Exit preview mode</button>
                </div>
              </div> 
              <hr/>
              <div className='flex flex-row pb-12'>
                <div className='mt-32 border-2 mx-16 rounded-md' style={{background: '#F5F7F9', width: '55%'}}>
                  <div className='h-12 flex flex-row py-4 px-2' style={{background: '#E5E8F0'}}>
                    <div className="rounded-xl mx-2 w-4 h-4 font-semibold" style={{background: '#A4B0CC'}}></div>
                    <div className="rounded-xl mx-2 w-4 h-4 font-semibold" style={{background: '#A4B0CC'}}></div>
                    <div className="rounded-xl mx-2 w-4 h-4 font-semibold" style={{background: '#A4B0CC'}}></div>
                  </div>
                    {html_render('900')}
                </div>
                <div className='mt-32 border-2 mx-6 p-6' style={{background: '#E5E8F0', borderRadius: '58px',height: 930, width: 470}}>
                  <div className='flex justify-center py-2 mb-4'>
                    <div className="rounded-xl mx-2 w-3 h-3 font-semibold" style={{background: '#A4B0CC'}}></div>
                    <div className="rounded-xl mx-2 w-24 h-3 font-semibold" style={{background: '#A4B0CC'}}></div>
                  </div>
                  <div className='p-0.5 overflow-hidden' style={{background: '#F5F7F9', borderRadius: '48px',height: '95%'}}>
                    {html_render('750')}
                  </div>
                </div>
              </div>
              </div>:
            <div>
              { exitModal &&
                <PopUpModals 
                title='Exit editor?'
                description={["Changes you have made may not be saved"]}
                onCancel='No'
                onPass='Exit'
                icon={exit_icon}
                onClose={exitEditor}
                onSave={() => { history.push(data.backPath) }}
              />
              }
              { revertModal &&
                <PopUpModals 
                title='Revert to original?'
                description={["Would you like to revert all the changes to the original template? ",<strong>All the changes you made will be lost.</strong>]}
                onCancel='Cancel'
                onPass='Revert'
                icon={revert}
                onClose={revertToOriginal}
                onSave={undoContent}
              />
              }
              <UnlayerEmailEditor
                initialVal={data.template_data} 
                updateValue={updateValue} 
                saveToDraft={saveToDraft}
                exitEditor={exitEditor}
                revertToOriginal={revertToOriginal}
              />
            </div>}
        </Spinner>
    )

}

   

export default MailConfig